import { motion } from "framer-motion";
import Reveal from "@/components/Reveal";

const chapters = [
  {
    n: "01",
    t: "One standard, end to end",
    d: "The same acceptance rules govern the file from the consultant's desk to the Council's asset system. What gets built is exactly what gets accepted.",
  },
  {
    n: "02",
    t: "Catch it before handover",
    d: "Validation belongs upstream — not after a rejection. Every issue surfaces while it's still cheap and fast to fix.",
  },
  {
    n: "03",
    t: "Consistency is the product",
    d: "ADAC only pays off when every submission looks the same. We make the standard repeatable across teams, projects and suppliers.",
  },
  {
    n: "04",
    t: "Audit-ready by default",
    d: "Every accepted file leaves a clean, defensible trail — so handover is a formality, not a negotiation.",
  },
];

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="bg-[#0A0A0C] text-white py-28 md:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#5b7fe0] font-mono">Manifesto</p>
          <h2 className="mt-5 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-[1.08]">
            Clean asset data isn't a document you chase. It's a standard you enforce.
          </h2>
        </Reveal>

        <div className="mt-16 border-t border-white/10">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.05}>
              <div className="group grid md:grid-cols-12 gap-4 md:gap-6 py-9 md:py-11 items-baseline border-b border-white/10 transition-colors hover:bg-white/[0.02]">
                <span className="md:col-span-2 font-mono text-sm text-[#5b7fe0]">{c.n}</span>
                <h3 className="md:col-span-4 font-heading text-2xl md:text-3xl font-medium tracking-tight">
                  {c.t}
                </h3>
                <p className="md:col-span-6 text-zinc-400 leading-relaxed">{c.d}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-12 font-mono text-sm text-zinc-500"
        >
          — WebADAC, on the way as-constructed data should flow.
        </motion.p>
      </div>
    </section>
  );
}
